/**
 * Small stateless render helpers extracted from useGameEngine.js as part of
 * the P-1 refactor pass. Each function is pure (no captured React state, no
 * closures) — takes ctx + data + cameraX and paints. Safe to import anywhere
 * a canvas context and the gameDataRef.current are available.
 *
 * Extracting these reduces useGameEngine.js size and pins any regression to
 * this small, easy-to-review module.
 */

// Draw sky/environment particles (rain, snow, embers etc.) with per-particle
// alpha. Uses white base color — background.js sets particle color separately.
export function drawEnvironmentParticles(ctx, data, cameraX) {
    const particles = data.environmentParticles || [];
    ctx.fillStyle = '#fff';
    for (const p of particles) {
        ctx.globalAlpha = p.alpha;
        ctx.beginPath();
        ctx.arc(p.x - cameraX, p.y, p.size, 0, Math.PI * 2);
        ctx.fill();
    }
    ctx.globalAlpha = 1;
}

// Muzzle-flash burst at data.muzzleFlash.{x,y}. Timer countdown lives on the
// data ref so the game loop's render cadence naturally drives fade-out.
export function drawMuzzleFlash(ctx, data, cameraX) {
    const mf = data.muzzleFlash;
    if (!mf || !mf.active || mf.timer <= 0) return;
    const screenX = mf.x - cameraX;

    ctx.save();
    ctx.globalAlpha = mf.timer / 3;

    // Outer glow
    const gradient = ctx.createRadialGradient(screenX, mf.y, 0, screenX, mf.y, 25);
    gradient.addColorStop(0, '#FFFF00');
    gradient.addColorStop(0.3, '#FF8800');
    gradient.addColorStop(1, 'transparent');
    ctx.fillStyle = gradient;
    ctx.beginPath();
    ctx.arc(screenX, mf.y, 25, 0, Math.PI * 2);
    ctx.fill();

    // Inner flash
    ctx.fillStyle = '#FFFFFF';
    ctx.beginPath();
    ctx.arc(screenX, mf.y, 8, 0, Math.PI * 2);
    ctx.fill();

    ctx.restore();
    mf.timer--;
    if (mf.timer <= 0) mf.active = false;
}
